'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { PropertyDetailListing } from '../types';
import type { ApartmentReviews, BuildingReviewsSnapshot } from '@/src/lib/api/endpoints/apartmentReviews';
import { useApartmentReviews } from '@/src/lib/hooks/query/useApartmentReviews';

const ReviewsContext = createContext<{
  lotId: string;
  reviews: ApartmentReviews | null;
  googlePlaceId?: string;
  redditTopics: NonNullable<ApartmentReviews['reddit']>['topics'];
}>({
  lotId: '',
  reviews: null,
  redditTopics: [],
});

export function ApartmentReviewsProvider({
  listing,
  snapshot,
  children,
}: {
  listing: PropertyDetailListing;
  snapshot?: BuildingReviewsSnapshot;
  children: ReactNode;
}) {
  const reviews = useApartmentReviews(listing, snapshot);
  const googlePlaceId = reviews?.google?.placeId;
  const redditTopics = reviews?.reddit?.topics ?? [];
  const lotId = listing.maloneLotIdEncoded ?? '';
  return (
    <ReviewsContext.Provider value={{ lotId, reviews, googlePlaceId, redditTopics }}>
      {children}
    </ReviewsContext.Provider>
  );
}

export const useApartmentReviewsContext = () => useContext(ReviewsContext);
